import cloneDeep from 'lodash.clonedeep';

export default function sanitizeScribeForTransport(dirtyScribe, stripId = false) {
  const scribe = cloneDeep(dirtyScribe);
  const { elements } = scribe;
  elements?.forEach(element => {
    if (element.type === 'Image' && typeof element.delete === 'function') {
      element.delete('_imageUrl');
    }
    if (element._imageUrl) {
      delete element._imageUrl;
    }
    if (element.image?.imgUrl) {
      delete element.image.imgUrl;
    }
  });

  if (stripId) {
    delete scribe.id;
  }

  return scribe;
}
